import SeekerDetails from "../components/SeatApprovalFlow/SeekerDetailsOverlay";
import { EmailTriggerOption } from "../pages/BulkEmailsPopUp/type";

export const QUESTION_MODAL_TEXT = {
  FORM: {
    LABELS: {
      QUESTION: "Question",
      TYPE: "Type*",
      OPTION: "Option",
      PLACEHOLDER: "Enter your question",
    },
    BUTTONS: {
      CANCEL: "Cancel",
      SUBMIT: "Submit",
      UPDATE: "Update",
      DUPLICATE: "Duplicate",
      ADD_OPTION: "Add Option",
    },
    SELECT: {
      CATEGORY_PLACEHOLDER: "Select Category",
    },
  },
  ERRORS: {
    OPTION_FETCH: "Error fetching options:",
    QUESTION_SUBMIT: "Error submitting question:",
    QUESTION_OPTION_ASSOCIATION: "Failed to create question-option association",
    QUESTION_CREATE: "Failed to create/update question",
  },
  VALIDATION: {
    REQUIRED_FIELDS: {
      QUESTION: "Question is required",
      TYPE: "Type is required",
    },
  },
};

export const OPTION_MODAL_TEXT = {
  FORM: {
    LABELS: {
      OPTION: "Option*",
      TYPE: "Type*",
      CATEGORY: "Category*",
      OPTION_PLACEHOLDER: "Enter option",
      OTHER_CATEGORY_PLACEHOLDER: "Enter other category",
    },
    BUTTONS: {
      CANCEL: "Cancel",
      SUBMIT: "Submit",
      UPDATE: "Update",
      DUPLICATE: "Duplicate",
    },
    SELECT: {
      CATEGORY_PLACEHOLDER: "Select Category",
    },
  },
  ERRORS: {
    CATEGORY_CREATE: "Failed to create category",
    SUBMIT: "Error submitting:",
  },
  TYPE_OPTIONS: [
    { value: "string", label: "String" },
    { value: "number", label: "Number" },
    { value: "boolean", label: "Boolean" },
  ],
  OTHER_VALUE: "Other",
};

// Common form field values
export const COMMON_FORM_FIELDS = {
  STATUS: {
    DRAFT: "draft",
    PUBLISHED: "published",
  },
  TEST_IDS: {
    OPTION_INPUT: "option-input",
    OTHER_CATEGORY_FIELD: "other-category-field",
    OTHER_CATEGORY_INPUT: "other-category-input",
    CANCEL_BUTTON: "cancel-button",
    SUBMIT_BUTTON: "submit-button",
  },
};

export const DEFINED_ROLES = [
  "mahatria",
  "admin",
  "finance_manager",
  "relational_manager",
  "shoba",
  "operational_manger",
];

export const TDS_APPLICATION_OPTIONS = [
  { value: "", label: "Select option" },
  { value: "base_only", label: "Base amount" },
  {
    value: "base_plus_tax",
    label: "Base amount with tax",
  },
];

export const PAYMENT_STATUSES = {
  ONLINE_PENDING: {
    value: "online_pending",
    label: "Online pending",
  },
  ONLINE_COMPLETED: {
    value: "online_completed",
    label: "Online completed",
  },
  OFFLINE_PENDING: {
    value: "offline_pending",
    label: "Offline pending",
  },
  OFFLINE_COMPLETED: {
    value: "offline_completed",
    label: "Offline completed",
  },
  FAILED: {
    value: "failed",
    label: "Failed",
  },
};

export const ApprovalStatus = {
  PENDING: "pending",
  APPROVED: "approved",
  REJECTED: "rejected",
  UNDER_REVIEW: "under_review",
  ON_HOLD: "on_hold",
  CANCELLED: "cancelled",
  YTD: "YTD",
  HOLD: "Hold",
};

export const USER_ROLE_MAHATRIA = "mahatria";
export const USER_ROLE_SHOBA = "shoba";
export const MENU_ID_HDB = "hdb";
export const API_LIMIT_100 = 100;

// User Preference Dropdown Constants
export const USER_PREFERENCE_DROPDOWN = {
  mahatriaChoiceUnallocated: "mahatriaChoiceUnallocated",
  preferencesUnallocated: "preferencesUnallocated",
  mahatriaChoiceBlessed: "mahatriaChoiceBlessed",
  preferencesHeading: "preferences",
  swapPreferencesHeading: "preferences",
  none: "none",
  selectToMove: "Select to move",
  mahatriaChoiceHold: "mahatriaChoiceHold",
  choice: "choice",
};
export const swapRequestPayload = {
  YTD: {
    name: "YTD",
    value: "yet-to-decide",
  },
  Hold: {
    name: "Hold",
    value: "hold",
  },
};
export const mousedown = "mousedown";
export const scroll = "scroll";
export const resize = "resize";

export const OVERALL_RATING_LABEL = "Overall rating is";
export const COMMENT_LABEL = "Comment";
export const YET_TO_REVIEW_LABEL = "Yet to review";
export const PASSION_LABEL = "Passion";
export const GROWTH_LABEL = "Growth";
export const INFINITHEIST_LABEL = "Infinitheist";
export const CONTINUITY_LABEL = "Continuity";
export const NO_EXPERIENCE = "No experiences to show";
export const CURRENT_RATING_IS = "Current rating is";

export const RecommendationLevelText = {
  Recommend: "How would you recommend this seeker?",
  WouldYouLikeToRecommend: "Has the seeker been following up with you?",
  FollowUpCount: "How many times has the seeker followed up?",
  Recommendation: "Followup",
  Comments: "Comments",
  RMReview: "RM review",
  rating: "Rating",
};
export const RecommendationText = "recommended";

export const CryptoTrailText = "--1#2@3$4%5^6*";

export const TravelFormText = {
  toastTitle: "Travel Form",
  toastMessage: "Travel form submitted successfully",
  toastType: "success",
}

export const BULKEMAIL = {
  SELECTION: 'selection',
  PREVIEW: 'preview',
  EMAIL_TRIGGERER: "Email Trigger",
  CANCEL: "cancel",
  CONTINUE: "continue",
  SEND: "send",
  VIEW_SEEKERS: "view seekers",
  TEST_MAIL: "test mail",
  SEEKERS_LIST: "Seekers List",
  toastTitle: "Bulk Email",
  toastMessage: {SUCCESS: "Bulk email sent successfully", WARNING: "Error sending bulk email",  NOSEEKERS: "No seekers found",},
  toastType: {SUCCESS: "success", WARNING: "warning"},
};

export const BUTTONLABELS={
  SAVE: "Save",
  CANCEL: "cancel",
  SUBMIT: "Submit",
  UPDATE: "Update",
  EDIT: "Edit",
  ADD: "Add",
  DELETE: "Delete",
  DOWNLOAD: "download",
  UPLOAD: "Upload",
}
export const REPORTS={
  DOWNLOAD_REPORT: "Downloading Report",
  REPORTNAME: "Report Name",
}
export const UN_BLESSED_FILTER_ID: number[] = [0,1,8,9,10]

export const textConstant = {
  REGISTRATIONS :"registrations",
  DASHBOARD: "dashboard",
  SEAT_ALLOCATIONS: "seat-allocations",
  DESC:"DESC",
  ASC:"ASC",
  DISABLEQUEUE:"Queue is disabled"
}

export const sortOptions = [
  { label: "Name", value: "fullName", initialOrder: "asc" },
  { label: "Age", value: "dob", initialOrder: "asc" },
  { label: "Registration Date", value: "registrationDate", initialOrder: "desc" },
  { label: "RM Rating", value: "averageRating", initialOrder: "asc" },
];
export const LABEL_ANY_HDB_MSD = "Any HDB/MSD"; 
export const SINGLE_PREFERENCE = "preference"; 
export const MULTIPLE_PREFERENCES = "preferences"; 
export const SEEKER_ASSOCIATION="Seeker’s association with infinitheism";
export const OTHER_EXPERIENCES="Other experiences"
export const PREFERENCE_LABEL="Preferences"


export const QUICK_VIEW_OVERLAY = {
  HEADER_TEXT: "Seeker Details",
  DETAILS_HEADING: "Details",
  QUICK_VIEW_HEADING: "Quick view of seeker",
  NO_DATA_MESSAGE: "No additional details available",
  EXCLUDED_FIELDS: [
    "seekerName",
    "gender", 
    "age",
    "location",
    "profilePictureUrl",
    "numberOfHDBs",
    "preferredRoomMate",
    "appliedOn",
  ],
  SINGLE_COLUMN_FIELDS: [
    "rmRating_grouped",
    "rmRecommendation_grouped"
  ],
  GROUPED_FIELDS: {
    rmRating: {
      primaryKey: "averageRating",
      secondaryKey: "rmComments",
      label: "RM rating",
      groupedKey: "rmRating_grouped",
    },
    rmRecommendation: {
      primaryKey: "recommendation",
      secondaryKey: "recommendationComments", 
      label: "RM recommendation",
      groupedKey: "rmRecommendation_grouped",
    },
  },
  STATUS_MAPPING: {
    approvalStatus: {
      pending: "Unassigned",
      rejected: "Hold",
      on_hold: "YTD"
    }
  },
  API_CONFIG: {
    LIMIT: 100,
    OFFSET: 0,
  },
  ERROR_MESSAGES: {
    FETCH_ERROR: "Error fetching seeker data:",
  }
};
export const PREVIOUS_RATING_LABEL=" rating is"
export const PREVIOUS_RATING_IS = "previous rating is"; 
export const PREVIOUS_RATING_IS_LABEL = "Previous rating is"; 


export const dropDownnJSON = {
  CANCELLED: {
    label: "Cancelled",
    value: "cancelled"
  },
  SWAP_REQUESTS: {
    label: "Swap requests",
    value: "swap requests"
  },
  ALL:{
    label: "All",
    value: "all"
  },
  UNASSIGNED:{
    label:"Unassigned",
    value:"unassigned"
  }
}

export const seekerExperiencesText = {
  HEADER_TEXT: "Add seeker experiences",
  UPDATE_HEADER_TEXT:"Update seeker experiences",
  NO_TAGS_MESSAGE: "No experiences to show",
  ERROR_MESSAGE: "Error fetching experiences",
  PLACEHOLDER_TEXT: "Select experiences",
  ADD_MORE:"Add More +"
};
export const PROFILE_IMAGE_ALT_TEXT = "Profile Image";
export const NO_SONG_PREFERENCE = "No song preference";

export const blessContent ={
  CHOOSE:"Choose a program to",
  BLESS:"bless",
  SWAP:"swap"
}
